/* 
Object:         PagerFirmware (Gebruiker)
Description:    Logic and events for the module User state (Gebruiker)
Used in:        PagerFirmware
*/


import * as appsettings     from "../appsettings";
import * as fileDownload    from "../fileDownload";
import * as viewmode        from "../viewmode";
import * as main            from "../main"

export function onChangeNewFirmwareVersion(e: kendo.ui.DropDownListChangeEvent): void {
    const dropDownList = e.sender; // typed as kendo.ui.DropDownList
    const selectedValue = dropDownList.value();
    console.log("Selected value:", selectedValue);

    refreshGrid();
}

export function refreshGrid(): void {

    var grid = $("#PagerFirmwareGrid").data("kendoGrid");

    if (grid != undefined) {
        grid.dataSource.read();
    }
}

function getFirmwareId(): number | null {

    const ddl = $("#DDL_NewFirmwareVersion").data("kendoDropDownList");

    if (ddl != null && ddl != undefined && ddl.value() != '') {
        return parseInt(ddl.value());
    }

    return null;
}

export function getAdditionalData(): { firmwareId: number } {
    const firmwareId = getFirmwareId();    

    return {
        firmwareId: firmwareId
    };
}

export function onLoadCarrierClick(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    e.preventDefault();

    const grid = $("#PagerFirmwareGrid").data("kendoGrid");
    const dataItem = grid.dataItem($(e.currentTarget).closest("tr")) as PagerFirmwareGridVM;

    // Optionally show a loader/spinner in the cell
    const $cell = $(e.currentTarget).closest("td");
    $cell.html('<span>Loading...</span>');

    // Call your controller to get the carrier name
    const url = 'PagerFirmware/GetCarrierName';
    $.getJSON(appsettings.getUrl(url), { userId: dataItem.UserID }, function (result) {
        // Update the cell in the grid with the new value
        $cell.html('<span>' + result.message + '</span>');
        //dataItem.set("CarrierName", result.message);

        // Optionally, re-render the cell (Kendo will do this automatically)
        //grid.refresh();
    });
}

export function extraToolbarButton0_Clicked(): void {
    const url = 'PagerFirmware/ExportAllUsersCurrentNode';
    const filename = 'Export_UsersStateAll_' + fileDownload.getDateTimeString() + '.xlsx';
    const loaderId = 'extraToolbarButton0Loader';
    fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
}

export function extraToolbarButton1_Clicked(): void {
    const url = 'PagerFirmware/ExportAllUsersNodesDown';
    const filename = 'Export_PagerFirmwaresAll_' + fileDownload.getDateTimeString() + '.xlsx';
    const loaderId = 'extraToolbarButton1Loader';
    fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
}

export function renderSVGs(e: kendo.ui.GridEvent): void {
    // For each SVG object in the grid, re-apply coloring logic
    $(".field-strength-svg").each(function () {
        const obj = this as HTMLObjectElement;
        const strength = $(obj).data("strength"); // Store strength as data attribute when rendering template

        if (strength != null) {
            obj.addEventListener('load', function () {
                const svgDoc = obj.contentDocument;
                if (svgDoc) {
                    const b = (strength + 24) / 25;
                    for (let i = 1; i <= b; i++) {
                        const bar = svgDoc.querySelector('#bar' + i);
                        if (bar) bar.setAttribute('fill', '#267F00');
                    }
                }
            });
        }
    });

    $(".battery-charge-svg").each(function () {
        const obj = this as HTMLObjectElement;
        const charge = $(obj).data("charge"); // Store charge as data attribute when rendering template

        if (charge != null) {
            obj.addEventListener('load', function () {
                const svgDoc = obj.contentDocument;
                if (svgDoc) {
                    const batteryFill = svgDoc.querySelector('.battery-fill');
                    const batteryText = svgDoc.querySelector('.battery-text');
                    batteryFill.setAttribute('width', `${charge}%`);
                    batteryText.textContent = `${charge} %`;
                    batteryFill.setAttribute('fill', valueToColor(charge));
                }
            });
        }
    });

    viewmode.setGridViewMode(e);
}

export function signalStrengthSvgTemplate(strength: number): string {
    const svgId = 'signalStrengthSvg_' + Math.random().toString(36).slice(2, 11);
    const imgUrl = appsettings.getUrl('/images/SignalStrength.svg');
    // Add data-strength attribute
    return '<object type="image/svg+xml" data="' + imgUrl + '" id="' + svgId + '" class="field-strength-svg" width="50" height="35" data-strength="' + strength + '"></object>';
}

export function batteryChargeSvgTemplate(chargePercentage: number): string {
    const svgId = 'batteryChargeSvg_' + Math.random().toString(36).slice(2, 11);
    const imgUrl = appsettings.getUrl('/images/BatteryCharge.svg');
    // Add data-charge attribute
    return '<object type="image/svg+xml" data="' + imgUrl + '" id="' + svgId + '" class="battery-charge-svg" width="50" height="35" data-charge="' + chargePercentage + '"></object>';
}

export function valueToColor(value: number): string {
    // Clamp value between 0 and 100
    value = Math.max(0, Math.min(100, value));
    let r, g, b = 0;

    if (value < 50) {
        // Red to Yellow
        r = 255;
        g = Math.round(255 * (value / 50));
        b = 0;
    } else {
        // Yellow to Green
        r = Math.round(255 * (1 - (value - 50) / 50));
        g = 255;
        b = 0;
    }

    // Convert to hex and pad with zeros if needed
    function toHex(x: number): string {
        const hex = x.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    }

    return '#' + toHex(r) + toHex(g) + toHex(b);
}

export function setFirmwareReady(): void {

    // Set firmware ready for x amount of devices.
        const selectedDevices: string[] = [];

    // Get selected compacts and or endpoints (nodeID).
    $("#PagerFirmwareGrid").data("kendoGrid").select().each(function (d) {
        selectedDevices.push($("#PagerFirmwareGrid").data("kendoGrid").dataItem(this).get("SerialNumber"));
    });

    if (selectedDevices.length > 0) {        
        const newFirmwareVersion = getFirmwareId();

        $.ajax({
            url: appsettings.getUrl("PagerFirmware/Update_Firmware"),
            type: "POST",
            data: JSON.stringify({
                serialNumbers: selectedDevices,
                newFirmwareVersion: newFirmwareVersion
            }),
            dataType: "json",
            contentType: 'application/json; charset=utf-8',
            success: function (responseData) {
                refreshGrid();

                if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                    main.makeResultMessage(responseData);
                }
            }
        });        
    }
}

export function rejectFirmwareUpdate(): void {
    
    const selectedDevices: string[] = [];

    // Get selected compacts and or endpoints (nodeID).
    $("#PagerFirmwareGrid").data("kendoGrid").select().each(function (d) {
        selectedDevices.push($("#PagerFirmwareGrid").data("kendoGrid").dataItem(this).get("SerialNumber"));
    });

    if (selectedDevices.length > 0) {       
        $.ajax({
            url: appsettings.getUrl("PagerFirmware/Cancel_Firmware"),
            type: "POST",
            data: JSON.stringify({ serialNumbers: selectedDevices }),
            dataType: "json",
            contentType: 'application/json; charset=utf-8',
            success: function (responseData) {
                refreshGrid();

                if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                    main.makeResultMessage(responseData);
                }
            }
        });        
    }
}